export enum WebSocketPayloadActionConnectionManagement {
  PING_SERVER = 'PING_PONG',
  WELLNESS_RESPONSE = 'HEARTBEAT'
}
